import API from '../../../../services/API';

export const mobilizationReport = (data) => {
  return API.request({
    url: '/mobilization/mobilizationFact',
    method: 'POST',
    data,
  });
};
